/**
 * General Pages Control Component
 * 
 * @package TopBuddy
 */

import { CheckboxControl, BaseControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const GeneralPagesControl = ({ value, onChange, availablePages }) => {
	// Handle checkbox change.
	const handleCheckboxChange = (pageSlug, checked) => {
		if (checked) {
			// Add the page slug to the array.
			onChange([...value, pageSlug]);
		} else {
			// Remove the page slug from the array.
			onChange(value.filter(slug => slug !== pageSlug));
		}
	};

	return (
		<div className="topbuddy-display-rules__field">
			<BaseControl
				label={__('Select General Page Types', 'topbuddy')}
				help={__('Choose the types of pages where this notification bar should appear', 'topbuddy')}
				id="topbuddy-general-pages"
			>
				<div className="topbuddy-display-rules__general-pages-grid">
					{Object.entries(availablePages).map(([slug, label]) => (
						<CheckboxControl
							key={slug}
							label={label}
							checked={value.includes(slug)}
							onChange={(checked) => handleCheckboxChange(slug, checked)}
						/>
					))}
				</div>
			</BaseControl>
		</div>
	);
};

export default GeneralPagesControl;
